import { Route } from '@lumapps/router';
import { AppId, URL_PREFIX } from '@lumapps/router/constants';

export const designerContentEditionRoute: Route = {
    appId: AppId.designer,
    path: `/${URL_PREFIX}/designer/content/edit/:id`,
    params: {
        // The content id.
        id: undefined,
    },
};

export const designerContentEdition = (contentId: string, spaceId?: string): Route => ({
    ...designerContentEditionRoute,
    params: { id: contentId },
    ...(spaceId && { query: { spaceId } }),
});

export const designerContentCreationRoute: Route = {
    appId: AppId.designer,
    path: `/${URL_PREFIX}/designer/content/create/:contentTypeId/:templateId?`,
    params: {
        // The custom content type ID.
        contentTypeId: undefined,
        // Optional template ID.
        templateId: undefined,
    },
};

export const designerContentCreation = (contentTypeId: string, templateId?: string, spaceId?: string): Route => ({
    ...designerContentCreationRoute,
    params: { contentTypeId, templateId },
    ...(spaceId && { query: { spaceId } }),
});
